import { createReducer, on } from '@ngrx/store';
import { MaintenanceScheduleDto } from '../../../../api/gse/models/maintenance-schedule-dto';
import { MaintenanceScheduleMinimalDto } from '../../../../api/gse/models/maintenance-schedule-minimal-dto';
import * as PmNotificationActions from './pm-notification.actions';

export interface PmNotificationState {
  items: MaintenanceScheduleMinimalDto[];
  totalRecords: number;
  loading: boolean;
  /** Raw failure from API (parsed for toast in `PMNotifications` only). */
  error: unknown | null;
  createJobCardSubmitting: boolean;
  createJobCardSuccess: boolean;
  /** Last create success `message` from `JobCardResponse` (for toast in component). */
  createJobCardSuccessMessage: string | null;
  detailsLoading: boolean;
  selectedItemDetails: MaintenanceScheduleDto | null;
}

export const initialState: PmNotificationState = {
  items: [],
  totalRecords: 0,
  loading: false,
  error: null,
  createJobCardSubmitting: false,
  createJobCardSuccess: false,
  createJobCardSuccessMessage: null,
  detailsLoading: false,
  selectedItemDetails: null,
};

export const pmNotificationReducer = createReducer(
  initialState,
  on(PmNotificationActions.loadPmNotifications, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PmNotificationActions.loadPmNotificationsSuccess, (state, { data, totalRecords, page, last }) => ({
    ...state,
    items: data,
    totalRecords,
    loading: false,
    page,
    last,
    error: null,
  })),
  on(PmNotificationActions.loadPmNotificationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(PmNotificationActions.createPmJobCard, (state) => ({
    ...state,
    createJobCardSubmitting: true,
    createJobCardSuccess: false,
    createJobCardSuccessMessage: null,
    error: null,
  })),
  on(PmNotificationActions.createPmJobCardSuccess, (state, { message }) => ({
    ...state,
    createJobCardSubmitting: false,
    createJobCardSuccess: true,
    createJobCardSuccessMessage: message?.trim() ? message.trim() : null,
    error: null,
  })),
  on(PmNotificationActions.createPmJobCardFailure, (state, { error }) => ({
    ...state,
    createJobCardSubmitting: false,
    createJobCardSuccess: false,
    error,
  })),
  on(PmNotificationActions.resetPmJobCardStatus, (state) => ({
    ...state,
    createJobCardSuccess: false,
    createJobCardSubmitting: false,
    createJobCardSuccessMessage: null,
  })),
  on(PmNotificationActions.loadPmNotificationDetails, (state) => ({
    ...state,
    detailsLoading: true,
    error: null,
  })),
  on(PmNotificationActions.loadPmNotificationDetailsSuccess, (state, { data }) => ({
    ...state,
    selectedItemDetails: data,
    detailsLoading: false,
    error: null,
  })),
  on(PmNotificationActions.loadPmNotificationDetailsFailure, (state, { error }) => ({
    ...state,
    detailsLoading: false,
    error,
  }))
);
